import { BASE_URL } from "./apiConfig";
//import { useMsal } from "@azure/msal-react";
//import { loginRequest } from "../authConfig";
//import { msalInstance } from "../msalinstance";
import apiClient from "./apiInstance";

const API_URL = BASE_URL;

// Get all rules and associated conditions and actions
export const fetchCustomerDetails = async (customeruniqueid) => {
    try {
        const response = await apiClient.get(`${API_URL}/getcustomerdetails`, {
            params: { customeruniqueid }, // Sending as query parameter
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching rules:", error);
        throw error;
    }
};

// Get all rules and associated conditions and actions
export const fetchCustomerDatabyDate = async () => {
    try {
        const response = await apiClient.get(
            `${API_URL}/getcustomerdatabydate`
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching rules:", error);
        throw error;
    }
};

// Get all rules and associated conditions and actions
export const publishdata = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/publishdata`);
        return response.data;
    } catch (error) {
        console.error("Error fetching rules:", error);
        throw error;
    }
};

// Get all rules and associated conditions and actions
export const approveconversation = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/approveconversation`);
        return response.data;
    } catch (error) {
        console.error("Error fetching rules:", error);
        throw error;
    }
};

export const updateCustomerData = async (id, updatedFields) => {
    try {
        const response = await apiClient.put(
            `${API_URL}/updateCustomerData/${id}`,
            updatedFields,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data; // Success response from the backend
    } catch (error) {
        console.error(
            `Error updating customer ${id}:`,
            error.response?.data || error.message
        );
        throw error; // Forward the error to be handled in the calling function
    }
};

export const updateCustomerCheckboxes = async (id, updatedFields) => {
    try {
        const response = await apiClient.put(
            `${API_URL}/updateCustomerCheckboxes/${id}`,
            updatedFields,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data; // Success response from the backend
    } catch (error) {
        console.error(
            `Error updating customer ${id}:`,
            error.response?.data || error.message
        );
        throw error; // Forward the error to be handled in the calling function
    }
};

export const uploadcsvfile = async (data) => {
    try {
        const response = await apiClient.post(
            `${API_URL}/uploadcsvfile`,
            { data },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data; // Success response from the backend
    } catch (error) {
        console.error(
            "Error uploading CSV file:",
            error.response?.data || error.message
        );
        throw error; // Forward the error to be handled in the calling function
    }
};

// Create or update actions
export const deleteCustomer = async (conditionid) => {
    try {
        const response = await apiClient.post(
            `${API_URL}/deletecondition/${conditionid}`
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting condition:", error);
        throw error;
    }
};

// Update an existing customer (requires customer ID)
export const fetchchat = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/fetchchat`);
        return response.data;
    } catch (error) {
        console.error("Error fetching chat:", error);
        throw error;
    }
};

export const updateChat = async (data) => {
    try {
        const response = await apiClient.put(`${API_URL}/updatechat`, {
            id: data.id,
            cararesponse: data.cararesponse,
            cararesponseapproved: data.cararesponseapproved,
        });
        return response.data;
    } catch (error) {
        console.error(
            "Error updating chat record:",
            error.response?.data || error.message
        );
        throw new Error("Failed to update chat record");
    }
};

export const endconversation = async (data) => {
    try {
        console.log("Sending to API:", data); // Debugging log
        const response = await apiClient.put(`${API_URL}/endconversation`, {
            customerdataid: data.customerdataid,
        });
        return response.data;
    } catch (error) {
        console.error(
            "Error ending conversation:",
            error.response?.data || error.message
        );
        throw new Error("Failed to end conversation");
    }
};

// Update the configuration
export const clientconfiguration = async (id, customerData) => {
    try {
        const response = await apiClient.put(
            `${API_URL}/clientconfiguration/${id}`,
            customerData,
            {
                headers: { "Content-Type": "application/json" },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating customer:", error);
        throw error;
    }
};

// Get client configuration
export const getclientconfiguration = async () => {
    try {
        const response = await apiClient.get(
            `${API_URL}/getclientconfiguration`
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching rules:", error);
        throw error;
    }
};

// get live chat data
export const getlivechat = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/getlivechat`);
        return response.data;
    } catch (error) {
        console.error("Error fetching chat:", error);
        throw error;
    }
};

export const getLiveEmail = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/getliveemail`);
        return response.data;
    } catch (error) {
        console.error("Error fetching email:", error);
        throw error;
    }
};

export const getmgrchat = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/getmgrchat`);
        return response.data;
    } catch (error) {
        console.error("Error fetching chat:", error);
        throw error;
    }
};

// get campaigns
export const getcampaigns = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/getcampaigns`);
        return response.data;
    } catch (error) {
        console.error("Error fetching chat:", error);
        throw error;
    }
};

// get inactive campaigns
export const getcampaignsinactive = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/getcampaignsinactive`);
        return response.data;
    } catch (error) {
        console.error("Error fetching chat:", error);
        throw error;
    }
};

// get live chat data
export const EditCampaign = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/editcampaign`);
        return response.data;
    } catch (error) {
        console.error("Error fetching chat:", error);
        throw error;
    }
};

// Add a New Campaign
export const AddCampaign = async (campaignData) => {
    try {
        const response = await apiClient.post(
            `${API_URL}/addCampaign`,
            campaignData,
            {
                headers: { "Content-Type": "application/json" },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error adding campaign:", error);
        throw error;
    }
};

// Delete a Campaign
export const DeleteCampaign = async (campaignID) => {
    try {
        const response = await apiClient.post(
            `${API_URL}/deleteCampaign`,
            { campaignID }, // Send campaign ID as request body
            {
                headers: { "Content-Type": "application/json" },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting campaign:", error);
        throw error;
    }
};

// get dashboard data
export const engagement = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/engagement`);
        return response.data;
    } catch (error) {
        console.error("Error fetching chat:", error);
        throw error;
    }
};

// get menu items from backend api
export const getmenuitems = async (accessToken) => {
    try {
        if (!accessToken) {
            throw new Error("Access token is required");
        }
        const response = await apiClient.get(`${API_URL}/userroles`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });

        const data = response.data;
        if (data && data.length > 0) {
            const user = data[0];
            return {
                id: user.id,
                firstname: user.firstname,
                lastname: user.lastname,
                emailaddress: user.emailaddress,
                role: user.role,
                ACSIdentity: user.ACSIdentity,
                workerid: user.workerid,
                userguid: user.userguid,
                ACSIdentityToken: user.ACSIdentityToken,
                ACSIdentityExpiration: user.ACSIdentityExpiration,
                usermenu: user.usermenu || [],
            };
        } else {
            return null;
        }
    } catch (error) {
        console.error("Error fetching menu items:", error);
        throw error;
    }
};

export const savePageVisits = async ({ agentid, agentguid, pageName, pageURL, visitDate }) => {
    try {
        const payload = {
            agentid,
            agentguid,
            pageName,
            pageURL,
            visitDate,
        };
        const response = await apiClient.post(`${API_URL}/pagevisits`, payload);
        return response.data;
    } catch (error) {
        console.error("Error saving page visits:", error);
        throw error;
    }
};

export const loginUser = async ({ emailaddress }) => {
    try {
        const response = await apiClient.post(`${API_URL}/login`, {
            emailaddress,
        }); // Modify the URL as per your backend
        return response.data; // Assuming the response contains the user data
    } catch (error) {
        console.error("Login API error:", error);
        throw error; // Rethrow to be caught in the LoginPage component
    }
};

// Get email data
export const getemailsinfo = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/getemailinfo`);
        return response.data;
    } catch (error) {
        console.error("Error fetching rules:", error);
        throw error;
    }
};

// Get email data
export const dataidemails = async (customerdataid) => {
    try {
        const response = await apiClient.get(`${API_URL}/dataidemails`, {
            params: { customerdataid: customerdataid }, // Explicitly setting the key-value pair
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching email records:", error);
        throw error;
    }
};

// Save email response
export const saveemailresponse = async ({ emailconvid, content, subject }) => {
    try {
        const response = await apiClient.post(`${API_URL}/saveemailresponse`, {
            emailconvid,
            content, // Pass the email content
            subject, // Pass the email subject
        });
        return response.data;
    } catch (error) {
        console.error(
            `Error saving email response (emailconvid: ${emailconvid}):`,
            error
        );
        throw error;
    }
};

// Send email response
export const sendemailresponse = async ({ emailconvid, content, subject }) => {
    try {
        const response = await apiClient.post(`${API_URL}/sendemailresponse`, {
            emailconvid,
            content, // Pass the email content
            subject, // Pass the email subject
        });
        return response.data;
    } catch (error) {
        console.error(
            `Error sending email response (emailconvid: ${emailconvid}):`,
            error
        );
        throw error;
    }
};

// Get email data
export const getcampaignusers = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/getcampaignusers`);
        return response.data;
    } catch (error) {
        console.error("Error fetching rules:", error);
        throw error;
    }
};

// Assign ticket to user
export const assignusers = async ({ userid }) => {
    try {
        const response = await apiClient.post(`${API_URL}/assignusers`, {
            userid,
        });
        return response.data;
    } catch (error) {
        console.error(`Error assigning user):`, error);
        throw error;
    }
};

// Get email data
export const dataidtexts = async (customerdataid) => {
    try {
        const response = await apiClient.get(`${API_URL}/dataidtexts`, {
            params: { customerdataid: customerdataid }, // Explicitly setting the key-value pair
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching email records:", error);
        throw error;
    }
};

// Get textl data
export const gettextinfo = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/gettextinfo`);
        return response.data;
    } catch (error) {
        console.error("Error fetching rules:", error);
        throw error;
    }
};